export default () => ({
  liveLocal: {},
  livelocalCategories: {},
  liveLocalManagement: {},
  liveLocalData: {}
})
